import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components'; // Input helper for Microsoft browsers - Internet Explorer 10, Internet Explorer 11, and Microsoft Edge

export var msInputStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ::-ms-clear,\n  ::-ms-reveal {\n    display: none;\n    height: 0;\n    width: 0;\n  }\n"])));